import { call, put, takeLatest } from 'redux-saga/effects';

import {
  receiveAPIResponse,
  requestAPI,
  requestAPIFailed,
} from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import {
  ADD_EXTRA_SECTION_ACTION,
  APPLY_CHANGE_TITLE_ACTION,
  APPLY_CHANGE_TITLE_KEY,
  EXTRA_SECTION_DATA_KEY,
  REFRESH_SECTIONS_DATA_SOURCE_ACTION,
  REPORT_DETAIL_DATA_KEY,
  SECTION_DETAIL_DATA_KEY,
  SECTION_REFRESH_DATA_SOURCE_KEY,
  UPDATE_DATA_NOTES_ACTION,
  UPDATE_DATA_NOTES_KEY,
} from 'src/redux/constants';
import type { ViewAction } from 'src/redux/viewState/types';
import { getActionAPISource } from 'src/utils';
import { receiveDataNotesResponse } from './actions';

export function* requestExtraSectionSaga(action: ViewAction) {
  yield put(
    requestAPI(EXTRA_SECTION_DATA_KEY, {
      url_format: { _id_: action.value },
      method: 'post',
    }),
  );
  yield put(requestAPI(REPORT_DETAIL_DATA_KEY, {}));
}

export function* watchRequestExtraSectionSaga() {
  yield takeLatest(ADD_EXTRA_SECTION_ACTION, requestExtraSectionSaga);
}

export function* updateDataNotesSaga(action: ViewAction) {
  const newDataNotesValue = action?.value?.value;

  try {
    let url = getActionAPISource(UPDATE_DATA_NOTES_KEY);
    url = url.replace(new RegExp('_id_', 'g'), action.value.sectionPk);
    const response = yield call(apiCallAsync, url, action.value, 'put');
    if (response.status === 200) {
      yield put(receiveAPIResponse(action.dataKey, response.data));
      yield put(
        receiveDataNotesResponse('ACR_SECTIONS_DETAIL', {
          data_notes: newDataNotesValue,
        }),
      );
    } else {
      throw 'API call has failed 7';
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* watchUpdateDataNotesSaga() {
  yield takeLatest(UPDATE_DATA_NOTES_ACTION, updateDataNotesSaga);
}

export function* postSectionTitleSaga(action: ViewAction) {
  try {
    let url = getActionAPISource(APPLY_CHANGE_TITLE_KEY);
    url = url.replace(new RegExp('_id_', 'g'), action.value.sectionPk);
    const response = yield call(apiCallAsync, url, action.value.title, 'post');
    if (response.status === 200) {
      yield put(receiveAPIResponse(action.dataKey, response.data));
      yield put(
        requestAPI(SECTION_DETAIL_DATA_KEY, {
          url_format: { _id_: action.value.sectionPk },
        }),
      );
    } else {
      throw 'API call has failed 9';
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* watchPostSectionTitleSaga() {
  yield takeLatest(APPLY_CHANGE_TITLE_ACTION, postSectionTitleSaga);
}

export function* requestDataSourcesRefreshForSectionSaga(action: ViewAction) {
  try {
    let url = getActionAPISource(SECTION_REFRESH_DATA_SOURCE_KEY);
    url = url.replace(new RegExp('_id_', 'g'), action.value);
    const response = yield call(apiCallAsync, url, {}, 'post');

    if (response.status >= 200 && response.status < 300) {
      yield put(receiveAPIResponse(action.dataKey, response.data));
      yield put(
        requestAPI(SECTION_DETAIL_DATA_KEY, {
          url_format: { _id_: action.value },
        }),
      );
    } else {
      throw 'API call has failed 10';
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.message));
    console.error(e);
  }
}

export function* watchRequestDataSourcesRefreshSaga() {
  yield takeLatest(
    REFRESH_SECTIONS_DATA_SOURCE_ACTION,
    requestDataSourcesRefreshForSectionSaga,
  );
}
